import React from "react";
import { IMAGE_UPLOAD_HINT } from "../utils/imageUploadPolicy";

/**
 * The single line of guidance that sits under every image upload field (plan §10.6):
 * "JPG, PNG, WebP, GIF or HEIC · up to 5 MB · we optimise it for you".
 *
 * Use this instead of writing the wording inline, so it can never drift out of step with what the
 * server actually accepts (utils/imageUploadPolicy.js mirrors utils/imageNormalizer.js).
 */
const FONT_SIZES = {
  sm: "11px",
  md: "12px",
  lg: "13px",
};

export default function ImageUploadHint({ size = "md", style, prefix }) {
  return (
    <div
      style={{
        fontSize: FONT_SIZES[size] || FONT_SIZES.md,
        color: "#6b7280",
        marginTop: "4px",
        lineHeight: 1.4,
        ...style,
      }}
    >
      {prefix ? `${prefix} ` : ""}
      {IMAGE_UPLOAD_HINT}
    </div>
  );
}
